import {
  Eyebrow,
  Inline,
  ToggleGroup,
  ToggleGroupItem,
} from "@generalapplications/ui";

export type BlogTagFilterProps = {
  tags: readonly string[];
  selectedTag: string | null;
  onSelectedTagChange: (tag: string | null) => void;
};

// Owns the ToggleGroup-to-blog-filter adaptation. Callers receive a semantic
// tag value rather than styling individual controls.
export function BlogTagFilter({
  tags,
  selectedTag,
  onSelectedTagChange,
}: BlogTagFilterProps) {
  if (tags.length === 0) return null;

  return (
    <Inline wrap gap="sm">
      <Eyebrow tone="muted" as="span">
        Filter
      </Eyebrow>
      <ToggleGroup
        value={selectedTag ?? "all"}
        onValueChange={(value) =>
          onSelectedTagChange(value !== "all" ? value : null)
        }
        variant="outline"
        tone="primary"
        wrap
        aria-label="Filter blog posts by tag"
      >
        <ToggleGroupItem value="all">All</ToggleGroupItem>
        {tags.map((tag) => (
          <ToggleGroupItem key={tag} value={tag}>
            {tag}
          </ToggleGroupItem>
        ))}
      </ToggleGroup>
    </Inline>
  );
}
